module.exports = __webpack_public_path__ + "img/P150T_weapon_22.cce99374.png";